export function isIOS(): boolean {
    const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    return iOS;
}

//does not crash in incognito iframe
export function getLocalStorage(key: string): string | null {
    try {
        return localStorage.getItem(key);
    } catch {
        console.log('Unable to read localstorage!');
        return null;
    }
}

export function setLocalStorage(key: string, value: string): unknown {
    try {
        localStorage.setItem(key, value);
        window.dispatchEvent(new Event('storage'));
        return;
    } catch {
        console.log('Unable to set localstorage!');
        return null;
    }
}

export function removeLocalStorage(key: string): void {
    try {
        localStorage.removeItem(key);
        window.dispatchEvent(new Event('storage'));
        return;
    } catch {
        console.log('Unable to set localstorage!');
        return;
    }
}
